import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';

import ChipField from '../../common/fields/ChipField';

const InvoiceTypeField = ({ source = 'invoice_type', size = 'small', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const types = {
		'credit': translate('Credit note'),
		'invoice': translate('Invoice')
	};

	const type = record[source];
	return (
		<ChipField source={type} record={types} {...props} />
	);
};

export default InvoiceTypeField;
